<template>
    <div class="container">
        <div class="ul" ref="currentList">
            <div class="add-container"
                 @click="add()">
                +
            </div>
            <div class="item"
                 v-for="(item, index) in data.data"
                 :key="item._id + String(index)"
                 :index="index">
                <div class="item-expand-button button flat-button"
                     @click="expandItem">
                    &lt;&gt;
                </div>
                <div class="form-group"
                     v-for="(value, field) in item"
                     :key="field">
                    <div class="label">{{map.nameMap[field]}}</div>
                    <component :is="map.getComponent(field)"
                               :ref="String(index) + field"
                               :field-name="field"
                               :class="{'field': true,
                                        'array-field': Array.isArray(value)}"
                               @click.native="itemClick(field, value, index, $event)"
                               :data="value"/>
                </div>
                <div class="button-container">
                    <div :class="{button: true,
                                 disabled: !unsaved}"
                            @click="remove(index)">
                        删除
                    </div>
                    <div :class="{button: true,
                                 disabled: !unsaved}"
                            @click="save(index)">
                        保存
                    </div>
                </div>
            </div>
        </div>
        <editable-list v-if="childData"
                       :data="childData"
                       class="next-list"
                       :template="childTemplate"
                       @save-parent="save(childIndex)"/>
    </div>
</template>

<script>
	import FieldMapService from "../services/FieldMapService";
	import ListModel from "./EditableListModel";
	import DatePicker from "./form/DatePicker";
	import LangPicker from "./form/LangPicker";
	import LinkPicker from "./form/LinkPicker";
	import MarkdownEditor from "./form/MarkdownEditor";
	import ArrayButton from "./form/ArrayButton";
	import TextInput from "./form/TextInput";
	import StaticLabel from "./form/StaticLabel";
	import ImagePicker from "./form/ImagePicker";
	import TextArea from "./form/TextArea";
	import NumericInput from "./form/NumericInput";

	export default {
		name: "EditableList",
		components: {
			NumericInput, TextArea, ImagePicker, StaticLabel, TextInput, ArrayButton,
            MarkdownEditor, LinkPicker, LangPicker, DatePicker},
        props: {
			data: {
				required: true,
				type: ListModel
			},
            template: {
				required: true,
                type: Object
            }
		},
		data() {
			return {
				childData: null,
                childIndex: 0,
                childTemplate: {},
				map: FieldMapService,
				unsaved: false
			}
		},
		methods: {
			itemClick(field, item, index, event) {
				let wasActive = event.target.classList.contains("active");
				let currentActive = this.$refs.currentList.querySelector(".active");
				if (currentActive) {
					currentActive.classList.remove("active");
				}
				if (Array.isArray(item)) {
					if (wasActive) {
						this.childData = null;
						this.childIndex = 0;
						this.childTemplate = {};
                    } else {
						this.childData = new ListModel(item);
						this.childIndex = index;
						this.childTemplate = this.template[field];
						event.target.classList.add("active");
                    }
				} else {
					this.childData = null;
				}
			},
			save(index) {
				let fields = this.$refs.currentList
                    .querySelectorAll(`.item[index="${index}"] .field`);
				for (let field of fields) {
					let fieldName = field.getAttribute("field-name");
					this.data.data[index][fieldName] = this.$refs[String(index) + fieldName][0].getValue();
				}
				this.$emit("save-parent");
			},
			remove(index) {
				if (confirm("确定要删除这条记录吗？")) {
					this.data.deleteItem(index);
				}
				this.$emit("save-parent");
			},
            add() {
                this.data.addItem(this.template);
            },
            expandItem(e) {
				let node = e.target.parentNode;
				node.classList.toggle("expanded");
            }
		}
	}
</script>

<style scoped lang="scss">
    .container {
        display: contents;
    }

    .item {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        padding: 16px;
        position: relative;
        border: $solid;
        margin-top: 32px;
        max-width: 50vw;
        width: 100%;
        box-sizing: border-box;
        animation: show-post 0.5s $bezier;
        transition: max-width 0.5s $bezier;
        @extend %card;
    }

    .item.expanded {
        max-width: 100%;
    }

    .item-expand-button {
        position: absolute;;
        right: 4px;
        top: 4px;
        border: $solid;
        padding: 4px;
    }

    @keyframes show-post {
        from {
            transform: translateY(2em);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .ul {
        display: flex;
        position: relative;
        flex-direction: column;
        align-content: center;
        align-items: center;
        flex-grow: 1;
        max-height: 100%;
        overflow-y: scroll;
        padding: 0 16px;
        flex-basis: 0;
    }

    .label {
        font-family: $serif;
    }

    .form-group {
        padding: 8px 0;
        border-bottom: $dotted;
    }

    .array-field {
        height: 32px;
        line-height: 32px;
        width: 80px;
        padding: 0;
        text-align: center;
        border: $solid;
        cursor: default;
    }

    .button-container {
        display: flex;
        flex-direction: row;
        padding: 8px 0;
    }

    .add-container {
        position: relative;
        min-height: 64px;
        font-size: 32px;
        line-height: 60px;
        box-sizing: border-box;
        width: 100%;
        max-width: 50vw;
        background-color: $p-bg;
        transition: min-height 0.3s $bezier, line-height 0.3s $bezier;
        margin-top: -1px;
        border: $solid;
        text-align: center;
        cursor: pointer;
        @extend %card;
    }

    .add-container:hover {
        min-height: 96px;
        line-height: 90px;
    }

    .add-container:active {
        background-color: $p-fg;
        color: $p-bg;
    }

    .button-container > .button {
        height: 32px;
        line-height: 32px;
        margin-right: 8px;
        padding: 0 16px;
    }

    .active {
        background-color: $p-fg;
        color: $p-bg;
    }

    .next-list::v-deep > .ul {
        border-left: double 4px $p-fg;
    }
</style>